import React from 'react';

import {
  Box,
  Chip,
  Stack,
  styled,
  Typography
} from '@mui/material';
import _ from 'lodash';
import {
  appEvents,
  pagination,
  routeDirectory
} from 'modules';
import {
  useLocation,
  useNavigate
} from 'react-router-dom';

import * as dataService from './dataService';



const ContainerBox = styled(Box)(({ theme }) => ({
  overflowX: 'scroll'
}));

const StyledChip = styled(Chip)(({ theme }) => ({
  border: '2px solid #649ead',
  color: '#649ead'
}));

const ClickableText = styled(Typography)({
  color: '#528898',
  cursor: 'pointer'
});



export interface IProps {
  onChangeLoading: (loading: boolean) => void;
}

export const FC: React.FC<IProps> = props => {
  const navigate = useNavigate();
  const location = useLocation();

  const control = pagination.useListPageControl({});
  const { data, loading, mutations, refetch } = dataService.useStartupsTabPane(control.paginationInput);
  const params = pagination.useStandardPaginationParams({
    page: data.page,
    control
  });



  React.useEffect(() => {
    props.onChangeLoading(loading);
  }, [loading, props]);




  React.useEffect(() => {
    const sub = appEvents.observable().subscribe(event => {
      if (event?.type === 'modal' && event.args === 'close') {
        refetch();
      }
    });

    return () => {
      sub.unsubscribe();
    };
  }, [refetch]);



  return (
    <ContainerBox>
      <pagination.PaginatedTable.FC
        canSelectRows
        paginationParams={params}
        data={data.page.nodes}
        columnDefs={[
          {
            label: 'Sign Up Date',
            fnRenderCell: row =>
              row.createdTimestamp.format('M/d/yyyy @ hh:mm a')
          },
          {
            label: 'Last Name',
            fnRenderCell: row => (
              <ClickableText onClick={() => {
                navigate(routeDirectory.investorProfile.path(row.id), {
                  state: {
                    prevPath: location.pathname
                  }
                });
              }}>
                {row.lastName}
              </ClickableText>
            )
          },
          {
            label: 'First Name',
            fnRenderCell: row => (
              <ClickableText onClick={() => {
                navigate(routeDirectory.investorProfile.path(row.id), {
                  state: {
                    prevPath: location.pathname
                  }
                });
              }}>
                {row.firstName}
              </ClickableText>
            )
          },
          {
            label: 'Company Name',
            fnRenderCell: row => row.companyName
          },
          {
            label: 'Email',
            fnRenderCell: row => row.email
          },
          {
            label: 'Phone',
            fnRenderCell: row => row.phoneNumber
          },
          {
            label: 'Investment Area',
            fnRenderCell: row => (
              <Stack
                spacing={1}
                direction="row">
                {_.map(row.investmentAreas, (area, index) =>
                  <Box key={index}>
                    <StyledChip
                      label={area}
                      variant="outlined" />
                  </Box>
                )}
              </Stack>
            )
          },
          {
            label: 'Investment Stage',
            fnRenderCell: row => (
              <Stack
                spacing={1}
                direction="row">
                {_.map(row.investmentStages, (stage, index) => (
                  <Box key={index}>
                    <StyledChip
                      label={stage}
                      variant="outlined" />
                  </Box>
                ))}
              </Stack>
            )
          }
        ]}

        rowActions={[
          {
            label: 'Create User Account',
            fnShouldHide: row => row.isClaimed,
            fnAction: id => {
              appEvents.broadcast({
                type: 'modal',
                args: {
                  type: 'createUserAccount',
                  userId: id,
                  defaultEmail: _.find(data.page.nodes, n => n.id === id)?.email ?? ''
                }
              });
            }
          },
          {
            label: 'Edit user',
            fnAction: id => {
              const user = _.find(data.page.nodes, node => node.id === id);

              if (!_.isUndefined(user)) {
                appEvents.broadcast({
                  type: 'modal',
                  args: {
                    type: 'editUserModal',
                    siteUserId: user.id,
                    companyProfileId: user.companyProfileId
                  }
                });
              }
            }
          },
          {
            label: 'Remove user',
            fnAction: id => appEvents.broadcast({
              type: 'modal',
              args: {
                type: 'confirm',
                title: 'Confirm user removal',
                body: 'Are you sure you want to remove this user?',
                onConfirm: async () => {
                  await mutations.deleteUsers([id]);
                }
              }
            })
          }
        ]}

        batchActions={[
          {
            label: 'Remove users',
            fnAction: async ids => {
              appEvents.broadcast({
                type: 'modal',
                args: {
                  type: 'confirm',
                  title: 'Confirm users removal',
                  body: 'Are you sure you want to remove these users?',
                  onConfirm: async () => {
                    await mutations.deleteUsers(ids);
                  }
                }
              });
            }
          }
        ]} />
    </ContainerBox>
  );
};
